import { ISubscriptionSearchParams, TSubscriptionFormData } from 'src/@types';
import { ISubscription } from 'src/@types/apiResponseTypes';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/v1/subscription';

/**
 * Subscription 목록 조회
 * @param params 검색 조건
 */
export const gets = async (params?: ISubscriptionSearchParams) => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<ISubscription[]>>(url, {
      params,
    });

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Subscription 단건 조회
 * @param SubscriptionSid Subscription 고유번호
 */
export const get = async (SubscriptionSid: number) => {
  try {
    const url = `${SUB_URL}/${SubscriptionSid}`;
    const response = await instance.get<TApiResponseData<ISubscription>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Subscription 등록
 * @param data Subscription 등록 정보: TSubscriptionFormData
 */
export const create = async (data: TSubscriptionFormData) => {
  try {
    const url = SUB_URL;

    const response = await instance.post<TApiResponseData<ISubscription>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Subscription 정보 수정
 * @param subscriptionSid Subscription 고유번호
 * @param data Subscription 등록 정보: TSubscriptionFormData
 */
export const update = async (subscriptionSid: number, data: TSubscriptionFormData) => {
  try {
    const url = `${SUB_URL}/${subscriptionSid}`;

    const response = await instance.put<TApiResponseData<ISubscription>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Subscription 삭제
 * @param subscriptionSid Subscription 고유번호
 */
export const remove = async (subscriptionSid: number) => {
  try {
    const url = `${SUB_URL}/${subscriptionSid}`;
    const response = await instance.delete<TApiResponseData<boolean>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      // 삭제 성공 시 true 반환
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
